import { useEffect } from 'react';

interface PdfModalProps {
  url: string;
  title?: string;
  onClose: () => void;
}

export function PdfModal({ url, title = 'Document', onClose }: PdfModalProps) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal modal-lg"
        onClick={(e) => e.stopPropagation()}
        style={{ display: 'flex', flexDirection: 'column', maxHeight: '90vh' }}
      >
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body" style={{ flex: 1, overflow: 'hidden', padding: 0 }}>
          <iframe
            src={url}
            title={title}
            style={{ width: '100%', height: '100%', minHeight: '70vh', border: 'none' }}
          />
        </div>
        <div className="modal-footer">
          <a href={url} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
            Open in new tab
          </a>
          <button className="btn btn-primary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
